import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth.guard';
import { hasPermissionsGuard } from '@guards/has-permissions.guard';
import { CambioEmisionPage } from './cambio-emision/cambio-emision.component';
import { ConstanciaSituacionFiscalPage } from './constancia-situacion-fiscal/constancia-situacion-fiscal.component';
import { OpinionCumplimientoPage } from './opinion-cumplimiento/opinion-cumplimiento.component';
import { CedulaIdentificacionFiscalPage } from './cedula-identificacion-fiscal/cedula-identificacion-fiscal.component';
import { RecuperacionCfdiPage } from './recuperacion-cfdi/recuperacion-cfdi.component';
import { RecuperacionDeclaracionPage } from './recuperacion-declaracion/recuperacion-declaracion.component';
import { CitaPersonaFisicaPage } from './cita-persona-fisica/cita-persona-fisica.component';
import { AltaRfcPrimeraVezConContrasenaPage } from './alta-rfc-primera-vez-con-contrasena/alta-rfc-primera-vez-con-contrasena.component';
import { AltaRfcPrimeraVezSinContrasenaPage } from './alta-rfc-primera-vez-sin-contrasena/alta-rfc-primera-vez-sin-contrasena.component';
import { CitaPersonaMoralPage } from './cita-persona-moral/cita-persona-moral.component';
import { ContrasenaCiecInePage } from './contrasena-ciec-ine/contrasena-ciec-ine.component';
import { RestablecerContrasenaPage } from './restablecer-contrasena/restablecer-contrasena.component';

let moduleName = 'sat';

export const sat: Routes = [
  {
    path: `${moduleName}/cambio-emision`,
    component: CambioEmisionPage,
    title: 'SAT - Cambio de emisión.',
    canActivate: [authGuard, hasPermissionsGuard(['sat_cambio_emision_access'])],
  },
  {
    path: `${moduleName}/constancia-situacion-fiscal`,
    component: ConstanciaSituacionFiscalPage,
    title: 'SAT - Constancia de situación fiscal.',
    canActivate: [authGuard, hasPermissionsGuard(['sat_constancia_situacion_fiscal_access'])],
  },
  {
    path: `${moduleName}/opinion-cumplimiento`,
    component: OpinionCumplimientoPage,
    title: 'SAT - Opinión del cumplimiento.',
    canActivate: [authGuard, hasPermissionsGuard(['sat_opinion_cumplimiento_access'])],
  },
  {
    path: `${moduleName}/cedula-identificacion-fiscal`,
    component: CedulaIdentificacionFiscalPage,
    title: 'SAT - Cédula de identificación fiscal.',
    canActivate: [authGuard, hasPermissionsGuard(['sat_cedula_identificacion_fiscal_access'])],
  },
  {
    path: `${moduleName}/recuperacion-cfdi`,
    component: RecuperacionCfdiPage,
    title: 'SAT - Recuperación de CFDI.',
    canActivate: [authGuard, hasPermissionsGuard(['sat_recuperacion_cfdi_access'])],
  },
  {
    path: `${moduleName}/recuperacion-declaracion`,
    component: RecuperacionDeclaracionPage,
    title: 'SAT - Recuperación de declaración.',
    canActivate: [authGuard, hasPermissionsGuard(['sat_recuperacion_declaracion_access'])],
  },
  {
    path: `${moduleName}/cita-persona-fisica`,
    component: CitaPersonaFisicaPage,
    title: 'SAT - Citas para persona física.',
    canActivate: [authGuard, hasPermissionsGuard(['sat_cita_persona_fisica_access'])],
  },
  {
    path: `${moduleName}/cita-persona-moral`,
    component: CitaPersonaMoralPage,
    title: 'SAT - Citas para persona moral.',
    canActivate: [authGuard, hasPermissionsGuard(['sat_cita_persona_moral_access'])],
  },
  {
    path: `${moduleName}/alta-rfc-primera-vez-con-contrasena`,
    component: AltaRfcPrimeraVezConContrasenaPage,
    title: 'SAT - Alta RFC por primera vez con contraseña.',
    canActivate: [authGuard, hasPermissionsGuard(['sat_alta_rfc_primera_vez_con_contrasena_access'])],
  },
  {
    path: `${moduleName}/alta-rfc-primera-vez-sin-contrasena`,
    component: AltaRfcPrimeraVezSinContrasenaPage,
    title: 'SAT - Alta RFC por primera vez sin contraseña.',
    canActivate: [authGuard, hasPermissionsGuard(['sat_alta_rfc_primera_vez_sin_contrasena_access'])],
  },
  {
    path: `${moduleName}/contrasena-ciec-ine`,
    component: ContrasenaCiecInePage,
    title: 'SAT - Contraseña CIEC con INE.',
    canActivate: [authGuard, hasPermissionsGuard(['sat_contrasena_ciec_ine_access'])],
  },
  {
    path: `${moduleName}/restablecer-contrasena`,
    component: RestablecerContrasenaPage,
    title: 'SAT - Restablecer contraseña.',
    canActivate: [authGuard, hasPermissionsGuard(['sat_restablecer_contrasena_access'])],
  },
];
